import React from 'react';
import { Box, Divider } from 'theme-ui';

import PaginationComponent from './Pagination';
import { Page, Pages, Total, Words, WordsRange } from '../types';

type Props = {
  range: WordsRange;
  total: Total;
  page: Page;
  pages: Pages;
  words: Words;
  onPageSelect: (page: number) => void;
};

const ResultsComponent: React.FC<Props> = ({
  range,
  total,
  page,
  pages,
  words,
  onPageSelect,
}) => {
  return (
    <Box mt={4}>
      <Divider />

      <Box
        sx={{
          display: 'flex',
          paddingX: 3,
        }}>
        {range || '0 - 0'} of {total}
        <PaginationComponent
          current={page}
          pages={pages}
          onSelect={onPageSelect}
        />
      </Box>

      <Divider />

      <Box my={4}>
        {words.map(({ word, definition }, index) => {
          return (
            <Box key={index}>
              <Box ml={3}>{word}</Box>
              {definition && (
                <Box bg="muted" px={3}>
                  <pre
                    style={{
                      wordBreak: 'break-word',
                      whiteSpace: 'pre-wrap',
                    }}>{`\n${definition}\n`}</pre>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>

      <PaginationComponent
        current={page}
        pages={pages}
        onSelect={onPageSelect}
      />
    </Box>
  );
};

export default ResultsComponent;
